import { Icon } from "@/components/icons/Icon";
import { Button, type Props as ButtonProps } from "@/components/sidebar/Button";
import { twMerge } from "@/utils/twMerge";

import type { ElementType, PropsWithChildren } from "react";

export type Props<T extends ElementType = "button"> = ButtonProps<T> & {
  tooltipTitle?: string;
  shortTitle?: string;
  contentClassName?: string;
  withArrow?: boolean;
};

export function ToggleButton<T extends ElementType = "button">({
  title,
  shortTitle,
  tooltipTitle,
  as,
  children,
  contentClassName,
  withArrow = true,
  ...rest
}: PropsWithChildren<Props<T>>) {
  const content = children || shortTitle || title;

  return (
    <Button as={as || "button"} title={tooltipTitle} aria-label={tooltipTitle} inverted {...rest}>
      {content && <div className={twMerge("ml-1 flex-1", contentClassName)}>{content}</div>}
      {withArrow && (
        <div className="flex ml-1.5 flex-shrink-0">
          <Icon name="ArrowDown" className="[&>path]:stroke-document-text" />
        </div>
      )}
    </Button>
  );
}
